import omit from "lodash/omit";
import { RestAPIClient } from "networks";
import { HTTPRequestMethods } from "networks/RestAPI/client";

import Paths from "./paths";
import {
  FileImage,
  FileImageUploadRequest,
  FileShareRequest,
  FileUploadRequest,
  FileDocumentResponse,
  FileMemberResponse,
} from "./types";

export const fileImageUploadService = (params: FileImageUploadRequest) => {
  const formData = new FormData();
  formData.append("scope", params.scope);
  formData.append("file", params.file);
  return RestAPIClient.call<FileImage>({
    method: HTTPRequestMethods.POST,
    url: Paths.ImageUpload,
    data: formData,
    config: {
      requireAuthentication: true,
      headers: {
        "Content-Type": "multipart/form-data",
      },
    },
  });
};

export const fileUploadService = (params: FileUploadRequest) => {
  const formData = new FormData();
  formData.append("scope", params.scope);
  formData.append("file", params.file);
  if (params.category) {
    formData.append("category", params.category);
  }
  return RestAPIClient.call<{ fileName: string; url: string }>({
    method: HTTPRequestMethods.POST,
    url: Paths.FileUpload,
    data: formData,
    config: {
      requireAuthentication: true,
      headers: {
        "Content-Type": "multipart/form-data",
      },
    },
  });
};

export const fileDocumentUploadService = (params: FileUploadRequest) => {
  const formData = new FormData();
  formData.append("scope", params.scope);
  formData.append("file", params.file);
  if (params.category) {
    formData.append("category", params.category);
  }
  return RestAPIClient.call<{ fileName: string; url: string }>({
    method: HTTPRequestMethods.POST,
    url: Paths.FileDocument,
    data: formData,
    config: {
      requireAuthentication: true,
      headers: {
        "Content-Type": "multipart/form-data",
      },
    },
  });
};

export const fileUploadAllService = ({
  employeeId,
  ...params
}: FileUploadRequest & { employeeId: number }) => {
  const formData = new FormData();
  formData.append("scope", params.scope);
  formData.append("file", params.file);
  if (params.category) {
    formData.append("category", params.category);
  }
  return RestAPIClient.call<FileImage>({
    method: HTTPRequestMethods.POST,
    url: Paths.FileUploadAll.replace("{employeeId}", String(employeeId)),
    data: formData,
    config: {
      requireAuthentication: true,
      headers: {
        "Content-Type": "multipart/form-data",
      },
    },
  });
};

export const fileListRequest = (params: {
  page?: number | null;
  limit?: number | null;
  employeeId: number;
  name?: string;
}) =>
  RestAPIClient.call<FileDocumentResponse>({
    method: HTTPRequestMethods.GET,
    url: Paths.FileUpload,
    config: {
      requireAuthentication: true,
      params,
    },
  });

export const fileDeleteRequest = (name: string) =>
  RestAPIClient.call({
    method: HTTPRequestMethods.DELETE,
    url: Paths.Detail?.replace("{name}", name),
    config: {
      requireAuthentication: true,
      byPassError: true,
    },
  });

export const fileDetailService = (name: string) =>
  RestAPIClient.call({
    method: HTTPRequestMethods.GET,
    url: Paths.Detail.replace("{name}", name),
    config: {
      requireAuthentication: true,
      responseType: "arraybuffer",
    },
  });

export const fileShareService = (params: FileShareRequest) =>
  RestAPIClient.call({
    method: HTTPRequestMethods.POST,
    url: Paths.FileShare.replace("{name}", params.name),
    config: {
      requireAuthentication: true,
    },
    data: omit(params, "name"),
  });

export const fileShareMemberListService = (params: {
  employeeId?: number | null;
  name: string;
}) =>
  RestAPIClient.call<FileMemberResponse>({
    method: HTTPRequestMethods.GET,
    url: Paths.FileShareMember.replace("{name}", params.name),
    config: {
      requireAuthentication: true,
      params: omit(params, "name"),
    },
  });
